import { useFlags } from 'launchdarkly-react-client-sdk';

// Single source of truth for the Web Studio rollout flag. Shared by the nav
// link/route in useEnterpriseAdminLinks and by the full-screen editor route in
// App.tsx (which lives outside that links loop so it can render without the
// AdminLayout sidebar) -- keeping the flag key and fallback in one place avoids
// the two gates drifting out of sync.
export function useShowWebStudioEditor(): boolean {
  const flags = useFlags();
  return flags['growth.ecomm.enterprise-web-studio-view.rollout'] ?? false;
}
